import axios from "utils/axios";
import { CustomAxiosRequestConfig } from "@xt/xtbase";
const URL = "/uaapi/uaa/";
const URL1 = "/uaapi/uaa/authorize/";
//获取二维码
export function get_qr(config: CustomAxiosRequestConfig) {
  return axios.get(URL + `authorize/token/qr`, config);
}

//获取二维码
export function get_qrResult(config: CustomAxiosRequestConfig) {
  return axios.get(URL + `authorize/token/qrResult`, config);
}

//获取密码公钥
export function post_passwdPublicKey(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/passwd/publicKey`, null, config);
}

//设置安全密码
export function post_tokenSetSafePwd(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/token/setSafePwd`, null, config);
}

//登录前置校验通过后下返回2fa验证项以及优先级
export function post_loginByFaBeforeCheck(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/v2/loginByFaBeforeCheck`, null, config);
}

//子账号登录前置校验通过后下返回2fa验证项以及优先级
export function post_subAccountloginByFaBeforeCheck(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/sub-account/loginByFaBeforeCheck`, null, config);
}

//通过2fa凭证登录
export function get_loginBy2Fa(faResultId: string | number, config: CustomAxiosRequestConfig) {
  return axios.get(URL + `authorize/loginBy2Fa/${faResultId}`, config);
}

//子账号 通过2fa凭证登录
export function get_subAccountloginBy2Fa(faResultId: string | number, config: CustomAxiosRequestConfig) {
  return axios.get(URL + `authorize/sub-account/loginBy2Fa/${faResultId}`, config);
}

//接口授权页面使用
export function get_oauth2Authorize(config: CustomAxiosRequestConfig) {
  return axios.get(URL + `oauth2/authorize`, config);
}

//多因子登录时，二次验证发送验证码
export function get_tokenSendCode(config: CustomAxiosRequestConfig) {
  return axios.get(URL1 + `token/send-code`, config);
}


//用户设备近6条 (废弃)
export function get_detaillist(config: CustomAxiosRequestConfig) {
  return axios.get(URL + `login/client-device/detail/list`, config);
}
//删除用户设备 (废弃-uaapi/account)
export function delete_clientDevice(config) {
  return axios.delete(URL + `login/client-device/delete`, config);
}

//用户设备分页
export function get_clientDevice(config) {
  return axios.get(URL + `login/client-device/page`, config);
}

//设备详细分页
// export function get_clientDeviceDetail(config:CustomAxiosRequestConfig) {
//   return axios.get(URL + `login/client-device/detail/page`, config);
// }

//用户设备清空（废弃-uaapi/account）
export function delete_clientDeviceClear(config: CustomAxiosRequestConfig) {
  return axios.delete(URL + `login/client-device/clear`, config);
}

// 登录日志列表
export function get_safeLog(config: CustomAxiosRequestConfig) {
  return axios.get(URL + "login/log/page", config);
}

// passkey pre-check
export function post_passkeyPreCheck(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/passkey/pre-check`, null, config);
}
// passkey begin
export function post_passkeyAuthenticateBegin(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/passkey/authenticate-begin`, null, config);
}
// passkey finish
export function post_passkeyAuthenticateFinish(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/passkey/authenticate-finish`, null, config);
}

// 谷歌联合登录：用 idToken 换 accessToken，有则登录无则注册再登录
export function post_authorizeGoogleToken(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/google/token`, config?.data ?? null, config);
}

// 苹果联合登录：用 id_token 换 accessToken，流程与谷歌一致
export function post_authorizeAppleToken(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/apple/token`, config?.data ?? null, config);
}

// 绑定第三方账号（邮箱已存在时输入密码绑定 Google/Apple）
export function post_bindThirdLogin(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `authorize/bindThirdLogin`, config?.data ?? null, config);
}

